import { Component, OnInit } from '@angular/core';

@Component({
  selector: "app-atpool",
  templateUrl: "./atpool.component.html",
  styleUrls: ["./atpool.component.css"],
})
export class AtpoolComponent implements OnInit {
  showButton = false;
  constructor() {}
  currentYear: number = new Date().getFullYear();

  ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/atpool/atpool.component.ts